import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonials = () => {
  const testimonials = [
    {
      text: `"ANISAKLA sayesinde düğünümüzdeki tüm fotoğrafları tek bir yerde topladık. Misafirlerimiz de kendi çektikleri fotoğrafları kolayca yükleyebildi. Harika bir hizmet!"`,
      category: 'Mutlu Çift',
      name: 'Ayşe ve Mehmet',
      img: 'assets/images/member-04.jpg',
    },
    {
      text: `"Oğlumun doğum günü partisindeki tüm anıları ANISAKLA'da sakladık. Artık her yıl büyüdüğünü görmek için bu anılara kolayca erişebiliyoruz. Çok teşekkürler!"`,
      category: 'Mutlu Anne',
      name: 'Zeynep K.',
      img: 'assets/images/member-01.jpg',
    },
    {
      text: `"Şirket etkinliklerimizin tüm fotoğraflarını ANISAKLA ile yönetiyoruz. Çalışanlarımız kendi fotoğraflarını yükleyebiliyor ve herkes tüm anılara erişebiliyor. Mükemmel bir sistem!"`,
      category: 'Şirket Yöneticisi',
      name: 'Ali Y.',
      img: 'assets/images/member-03.jpg',
    },
  ];

  return (
    <div className="section testimonials" id="team">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <Swiper
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000 }}
              loop={true}
              className="swiper-testimonials"
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="item">
                    <p>{item.text}</p>
                    <div className="author">
                      <img src={item.img} alt={item.name} />
                      <span className="category">{item.category}</span>
                      <h4>{item.name}</h4>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="col-lg-5 align-self-center">
            <div className="section-heading">
              <h6>KULLANICI YORUMLARI</h6>
              <h2>Kullanıcılarımız ne diyor?</h2>
              <p>
                ANISAKLA'yı kullanan binlerce mutlu kullanıcımızın deneyimlerini okuyun.
                Anılarını güvenle saklayan ve sevdikleriyle paylaşan kullanıcılarımızın memnuniyeti bizim için en büyük motivasyon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
